import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Btn } from "@/components/Btn";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const STEPS = [
  ["01", "Refer", "Recommend Wave Eleven to a business that needs a website."],
  ["WAVE200", "Use the code", "Tell them to use referral code WAVE200 and give us your name or business name when they start their project."],
  ["£200", "Get paid", "If they purchase a qualifying Wave Eleven website, we'll pay you £200."],
];

const TERMS = [
  "£200 is paid for each successful qualifying website referral.",
  "The referred customer must become a paying Wave Eleven website client.",
  "One referrer per customer.",
  "Self-referrals do not qualify.",
  "Cancelled or refunded projects do not qualify.",
  "Referral commission is paid after the qualifying customer payment has cleared.",
  "There is no minimum number of referrals.",
  "There is no maximum number of successful referrals.",
  "The £200 referral applies to qualifying website purchases only — not the £175 Google Business or Social Media services.",
];

export default function Referrals() {
  return (
    <>
      <PageHero eyebrow="Wave Eleven Referral Programme" title="Know a business that needs" accent="a new website?"
        subtitle="Recommend them to Wave Eleven and we'll pay you £200 if they become a website client. No sign-up. No targets. No limits." />

      <section className="bg-paper text-ink">
        <div className="mx-auto max-w-[1100px] px-6 py-24 md:px-12 md:py-28">
          <div className="grid gap-10 md:grid-cols-3">
            {STEPS.map(([mark, title, copy]) => (
              <Reveal key={title} delay={0.05}>
                <div className="border-t border-ink/15 pt-6">
                  <p className="font-serif text-3xl text-champagne">{mark}</p>
                  <p className="mt-3 text-[11px] uppercase tracking-label">{title}</p>
                  <p className="mt-3 text-sm leading-relaxed text-ink/65">{copy}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-16 flex flex-col items-start justify-between gap-6 border-t border-ink/12 pt-10 sm:flex-row sm:items-center">
              <p className="max-w-lg text-lg leading-relaxed text-ink/75">Ready to refer someone? Ask them to enter code <span className="font-medium">WAVE200</span> and your name when they start their project.</p>
              <Btn to="/start" variant="primary" testid="referrals-start">Start a Project</Btn>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-16">
              <Accordion type="single" collapsible>
                <AccordionItem value="terms" data-testid="referral-terms" className="border-t border-ink/12">
                  <AccordionTrigger className="py-5 text-left text-[11px] uppercase tracking-label text-ink hover:no-underline">Referral programme terms</AccordionTrigger>
                  <AccordionContent className="pb-6">
                    <ul className="space-y-3">
                      {TERMS.map((t) => (<li key={t} className="flex items-baseline gap-3 text-sm leading-relaxed text-ink/65"><span className="h-1 w-1 shrink-0 bg-champagne" />{t}</li>))}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
